import { render, staticRenderFns } from "./SettingsPlate.vue?vue&type=template&id=3c8bb53a&"
import script from "./SettingsPlate.vue?vue&type=script&lang=js&"
export * from "./SettingsPlate.vue?vue&type=script&lang=js&"
import style0 from "./SettingsPlate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SettingsPlate.vue"
export default component.exports